import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import strings from "translate/language";
import AllocatePropertyModal from "../../component/common/AllocatePropertyModal";
import {
  accountNumberValid,
  certificateNumber,
  gstNumberValid,
  ifscValid,
  nameValid,
  seo,
  ValidateExtensionImge,
  getAge,
} from "utils/utils";
import {
  SourcingManager,
  SourcingTL,
  sourcing_head_id,
  SCM,
} from "utils/constants";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import Breadcrumb from "component/common/breadcrumb";
import { addChannelPartner } from "reduxStore/action/channelPartnerAction";
import {
  checkEmailMobile,
  getSMlist,
  addCpToBucket,
  removeAddCptoBucket,
  channelPartnerDetail,
  removeEmailMobileCheck,
  updateChannelPartner,
} from "../../reduxStore/action/channelPartnerAction";
import {
  getFileExtension,
  emailAddressValid,
  mobileNumberValid,
  handleDetailResponse,
} from "utils/utils";
import { getAllProperty } from "reduxStore/action/propertyActions";
import { errorToast, apiCall, successToast } from "../../utils/httpClient";
import Input from "component/Input";
import { getReportPropertyList } from "reduxStore/action/reportActions";
import { removeModalClass } from "utils/modalHandler";
import moment from "moment";
import apiEndPoints from "utils/apiEndPoints";
import ImageRender from "component/common/ImageRender";
import PdfViewer from "../../component/common/pdfViewer";

const AddNewCP = () => {
  const navigate = useNavigate();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const dispatch = useDispatch();
  const [form, setForm] = useState({});
    const [pdfUrl, setPdfUrl] = useState(null);
      const [isPdfView, setIsPdfView] = useState(false);
  const [formVaild, setFormVaild] = useState(null);
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [cheaqueImage, setCheaqueImage] = useState({ preview: "", raw: "" });
  const [propidershipImage, setPropidershipImage] = useState({ preview: "", raw: "" });
  const [pancardImage, setPancardImage] = useState({ preview: "", raw: "" });
  const [propertyList, setPropertyList] = useState([]);
  const [finalPropertyList, setFinalPropertyList] = useState([]);
  const [cp_type, setCpType] = useState(2);
  const [employee, setEmployee] = useState([]);
  const [empEmailMobile, setEmpEmailMobile] = useState({
    employeeMobile: null,
    employeeEmail: null,
  });

  const [showModal, setShowModal] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [empform, setEmpform] = useState({
    employeeName: "",
    employeeMobile: "",
    employeeEmail: "",
    employeeGender: "",
  });
  const [empFormVaild, setEmpFormVaild] = useState({
    employeeMobile: false,
    employeeEmail: false,
  });

  // const [bucketCpId,setBucketCpId] = useState("")
  const [bucketCpLgId, setBucketCpLgId] = useState("");

  const [cpdata, setCpData] = useState({});

  const [modalShow, setModalShow] = useState(false);

  const [selectedProperties, setSelectedProperties] = useState([]);

  const handleAllocateClick = () => {
    setModalShow(true); // Show the modal
  };

  const handlePropertiesSelected = (properties) => {
    setSelectedProperties(properties);
  };

  const location = useLocation();
  const [cpId, setCpId] = useState(null);

  useEffect(() => {
    // Create a URLSearchParams instance from the query string
    const queryParams = new URLSearchParams(location.search);
    const cpIdFromQuery = queryParams.get("cp_id"); // Get the 'leadid' query parameter

    // Set leadId state
    setCpId(cpIdFromQuery);
  }, [location.search]);

  const addChannelPartnerSelector = useSelector(
    (state) => state.channelPartner
  );

  const empEmailMobileCheck = useSelector((state) => state.empEmailMobileCheck);

  const { response: res } = useSelector((state) => state.login);

  const propertyData = useSelector((state) => state.propertyData);

  useEffect(() => {
    const fetchProperties = async () => {
      if (cpId) {
        const params = { cp_id: form?.cp_lg_id };
        try {
          const res = await apiCall(
            "post",
            apiEndPoints.GET_CP_PROPERTY_FOR_SM,
            params
          );
          const response = res?.data;

          if (response?.status === 200) {
            if (response?.data?.length > 0) {
              
              setSelectedProperties(response?.data); // Store filtered properties based on cp_id
            } else {
              setSelectedProperties([]); // No properties found
            }
          } else {
            setSelectedProperties([]); // Error response, reset the property list
          }
        } catch (error) {
          console.error("Error fetching properties:", error);
          setSelectedProperties([]); // In case of an error, reset the property list
        }
      }
    };

    fetchProperties();
  }, [cpId, form?.cp_lg_id]);

  useEffect(() => {
    dispatch(
      getAllProperty({
        offset: 0,
        limit: "",
      })
    );

    if (cpId) {
      dispatch(channelPartnerDetail({ cp_id: cpId }));
    }
  }, [cpId, dispatch]);

  useEffect(() => {
    if (addChannelPartnerSelector.detail) {
      const { response } = addChannelPartnerSelector;
      if (response?.status === 200) {
        setCpData(handleDetailResponse(response.data));
        const result = handleDetailResponse(response.data);


        setForm((prevForm) => {
          // Compare if the form data has changed to avoid unnecessary re-renders
          if (
            prevForm.agent_name !== result?.agent_name

            // add more comparisons as necessary for other fields
          ) {
            return {
              ...prevForm,
              cp_id: result?.cp_id,
              pin_code: result?.pin_code,
              address: result?.address,
              email: result?.email,
              rera_registration: result?.rera_registration,
              owner_name: result?.agent_name,
              cp_type: result?.cp_type,
              gstApplicable: result?.gstApplicable,
              agent_name: result?.agent_name,
              primary_mobile: result?.primary_mobile,
              whatsapp_number: result?.whatsapp_number,
              adhar_no: result?.adhar_no,
              pancard_no: result?.pancard_no,
              gender: result?.gender,
              date_of_birth: result?.date_of_birth,
              rera_start_date: result?.rera_start_date,
              rera_end_date: result?.rera_end_date,
              pincode: result?.pin_code,
              location: result?.location,
              latitude: result?.latitude,
              longitude: result?.longitude,
              bank_name: result?.cp_bank_detail?.bank_name,
              branch_name: result?.cp_bank_detail?.branch_name,
              account_no: result?.cp_bank_detail?.account_no,
              ifsc_code: result?.cp_bank_detail?.ifsc_code,
              gst: result?.gst,
              working_location: result?.working_location,
              company_employee: result?.company_employee,
              property_tag: result?.property_tag,
              rera_certificate_no: result?.rera_certificate_no,
              rera_certificate: result?.rera_certificate,
              cp_lead_type: result?.rera_certificate,
              cp_lg_id: result?.login_id,
              cancel_cheaque:result.cp_bank_detail?.cancel_cheaque,
              pancard:result.pancard
            };
          }
          return prevForm; // Don't update if there is no change
        });


      }
    }
  }, [addChannelPartnerSelector]);

 
  const selectedPropertyIds = [];
  useEffect(() => {
    if (selectedProperties.length > 0) {
      // Extract _id from each selected property and push to form.property_tag
      selectedProperties.forEach((property) => {
        // Check if the _id is not already in form.property_tag before pushing it
        if (!form.property_tag.includes(property._id)) {
          selectedPropertyIds.push(property._id);
          form.property_tag.push(property._id);
        }
      });
    } else {
      form.property_tag = []; // Reset if no properties are selected
    }
  }, [form, selectedProperties, selectedPropertyIds]);
 

  useEffect(() => {
    if (propertyData?.response) {
      const { response, loading, list } = propertyData;
      if (response?.status === 200 && response?.data?.length > 0) {
        setPropertyList(response?.data?.filter((el) => el?.status === true));
        setFinalPropertyList(response?.data?.filter((el) => el?.status === true));
      } else {
        setPropertyList([]);
      }
    }
  }, [propertyData]);

  const transformedArray = propertyList.map((item) => ({
    property_id: item._id,
    active_status: item.status,
    _id: item?._id,
    property_title: item?.property_title,
    property_type: item?.property_type,
  }));

  const handleConfirm = () => {
    setConfirmed(true);
    setShowModal(false);
    // Dispatch the action only if confirmed
    if (bucketCpLgId) {
      dispatch(addCpToBucket({ cp_id: [bucketCpLgId] }));
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalShow(false);
    dispatch(removeEmailMobileCheck());
    dispatch(removeAddCptoBucket());
  };

  const SMteam =
    SourcingTL === res?.data?.role_id ||
    SourcingManager === res?.data?.role_id ||
    sourcing_head_id === res?.data?.role_id ||
    SCM === res?.data?.role_id;

  useEffect(() => {
    if (addChannelPartnerSelector.create === true) {
      if (addChannelPartnerSelector?.response?.status === 200) {
        setForm({});
        navigatpage("/channelpartner");
      }
    } else {
      if (
        addChannelPartnerSelector?.response?.status === 200 &&
        addChannelPartnerSelector?.update === true
      ) {
        smFunction();
      }
    }
  }, [addChannelPartnerSelector]);

  const smFunction = async () => {
    const params = {
      cp_id: bucketCpLgId,
      property_tag: JSON.stringify(transformedArray),
    };
    
    const response = await apiCall(
      "post",
      apiEndPoints.UPDATE_CP_PROPERTY_SM,
      params
    );

    if (response?.data?.status === 200) {
      successToast("Cp added to bucket sucessfully");

      dispatch(removeEmailMobileCheck());
      dispatch(removeAddCptoBucket());
      navigate("/channelpartner");
    }
  };

  useEffect(() => {
    if (empEmailMobileCheck?.response?.status) {
      if (empEmailMobileCheck?.response?.status === 200) {
        if (empEmailMobileCheck?.response?.message?.includes("email")) {
          setEmpFormVaild({
            ...empFormVaild,
            employeeEmail: false,
          });
        } else if (empEmailMobileCheck?.response?.message?.includes("mobile")) {
          setEmpFormVaild({
            ...empFormVaild,
            employeeMobile: false,
          });
        } else {
        }
      } else {
        if (!cpId) {
          if (empEmailMobileCheck?.response?.status === 201) {
            if (empEmailMobileCheck?.response?.message?.includes("email")) {
              setEmpFormVaild({
                ...empFormVaild,
                employeeEmail: empEmailMobileCheck.response.message,
              });
              errorToast(empEmailMobileCheck?.response?.message);
              setForm({
                ...form,
                email: "", // Reset email field
              });
            } else if (
              empEmailMobileCheck?.response?.message?.includes("mobile")
            ) {
              setEmpFormVaild({
                ...empFormVaild,
                employeeMobile: empEmailMobileCheck.response.message,
              });
              errorToast(empEmailMobileCheck?.response?.message);
              setForm({
                ...form,
                primary_mobile: "", // Reset mobile field
              });
            } else {
              errorToast(empEmailMobileCheck?.response?.message);
              if (empEmailMobileCheck?.update === true) {
                if (SMteam) {
                  setBucketCpLgId(empEmailMobileCheck?.response?.cp_lg_id);

                  if (!confirmed && !showModal) {
                    setShowModal(true);
                  }

                  // dispatch(addCpToBucket({cp_id:empEmailMobileCheck?.response?.cp_lg_id}));
                }
              }

              setForm({
                ...form,
                rera_certificate_no: "", // Reset RERA certificate field
              });
            }
          }
        }
      }
    }
  }, [empEmailMobileCheck, cpId]);

  useEffect(() => {
    dispatch(getSMlist());
  }, []);

  useEffect(() => {
    setForm({
      owner_name: "",
      gender: "",
      date_of_birth: "",
      primary_mobile: "",
      whatsapp_number: "",
      email: "",
      working_location: [],
      rera_certificate_no: "",
      rera_certificate: null,
      rera_certificate_name: "",
      cancel_cheaque: null,
      cancel_cheaque_name: "",
      pancard: null,
      pancard_name: "",
      propidership_declaration_letter: null,
      propidership_declaration_letter_name: "",
      bank_name: "",
      branch_name: "",
      account_no: "",
      ifsc_code: "",
      gst: "",
      location: "",
      workingLocation: "",
      latitude: "",
      longitude: "",
      company_employee: [],
      pincode: "",
      rera_start_date: "",
      rera_end_date: "",
      property_tag: [],
    });
    setEmpform({
      employeeName: "",
      employeeMobile: "",
      employeeEmail: "",
      employeeGender: "",
      employeeRera_no: "",
    });
    setFormVaild(null);
    setEmpFormVaild(null);
  }, [cp_type]);

  const handleChange = (e) => {
    if (e.target.files.length) {
      const validFile = ValidateExtensionImge(e.target.files[0]);
      let preview = "";
      let image = "";
      if (validFile === true) {
        preview = URL.createObjectURL(e.target.files[0]);
        image = e.target.files[0];
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: null,
        });
      } else {
        preview = "";
        image = "";
        setFormVaild({
          ...formVaild,
          images: null,
          validMedia: validFile,
        });
      }
      const nextFormState = {
        preview: preview,
        raw: image,
      };
      setImage(nextFormState);
    }
  };

  const reraRegex = new RegExp(/^(UPRERA[A-Z]{3}\d{0,8}|[A-Z]\d{11,12})$/);
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]:
        e.target.name === "adhar_no"
          ? e.target.value
              .replace(/\D/g, "")
              .split(/(?:([\d]{4}))/g)
              .filter((s) => s.length > 0)
              .join(" ")
          : e.target.value,
    };
    setForm(nextFormState);

    if (e.target.name === "rera_certificate_no") {
      // Check if the input value matches the regex pattern
      if (e.target.value.length > 17) {
        e.target.value = e.target.value.slice(0, 17);
      }
      if (!reraRegex.test(e.target.value)) {
        // Update the form validation state with the error message if the input is invalid
        setFormVaild({
          ...formVaild,
          rera_certificate_no: strings.validCertificateNo, // Adjust the error message as per requirement
        });
      } else {
        // Reset the error message when input is valid
        setFormVaild({
          ...formVaild,
          rera_certificate_no: "",
        });
      }
    }

    if (e.target.name === "email") {
      if (emailAddressValid(e.target.value)) {
        dispatch(checkEmailMobile({ email: e.target.value }));
      }
    }

    if (e.target.name === "rera_certificate_no") {
      if (certificateNumber(e.target.value)) {
        dispatch(checkEmailMobile({ rera_certificate_no: e.target.value }));
      }
      if (checkForDuplicateField("empolyeeReraNo", e.target.value) && form.rera_certificate_no === e.target.value) {
        setFormVaild({
          ...formVaild,
          rera_certificate_no: "Already added this Rera No", // Adjust the error message as per requirement
        });
      }
    }

    if (e.target.name === "primary_mobile") {
      if (e.target.value.length >= 10) {
        dispatch(checkEmailMobile({ mobile: e.target.value }));
      }
    }

    // Update the form state with the new value
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

    if (
      e.target.name === "rera_start_date" ||
      e.target.name === "rera_end_date"
    ) {
      const newValue = new Date(e.target.value).toISOString();

      setForm((prevForm) => ({
        ...prevForm,
        [e.target.name]: newValue,
      }));
    }

     if (e.target.name === "rera_end_date") {
      const startDate = new Date(form.rera_start_date);
      const endDate = new Date(e.target.value);
      if (endDate < startDate) {
        setFormVaild({
          ...formVaild,
          rera_end_date: "End date should not be before start date",
        });
      } else {
        setFormVaild({
          ...formVaild,
          rera_end_date: "",
        });
      }
    }
  
  };


  const handleEmployeeField = (e) => {
    const nextFormState = {
      ...empform,
      [e.target.name]: e.target.value,
    };
    
    setEmpform(nextFormState);
   
    if (e.target.name === "employeeMobile") {

      // if (empEmailMobile?.employeeMobile !== e.target.value) {
      //   setEmpFormVaild({
      //     ...empFormVaild,
      //     employeeMobile: false,
      //   });
      // } else {
      //   setEmpEmailMobile({
      //     employeeMobile: "",
      //   });
      // }
    } else if (e.target.name === "employeeEmail") {
  
    
      // if (empEmailMobile?.employeeEmail !== e.target.value) {
      //   setEmpFormVaild({
      //     ...empFormVaild,
      //     employeeEmail: false,
      //   });
      // } else {
      //   setEmpEmailMobile({
      //     employeeEmail: "",
      //   });
      // }
    }else if(e.target.name === "empolyeeReraNo"){
      setEmpFormVaild({
        ...formVaild,
        empolyeeReraNo: "", // Adjust the error message as per requirement
      });
      if (checkForDuplicateField("empolyeeReraNo", e.target.value)) {
        setEmpFormVaild({
          ...formVaild,
          empolyeeReraNo: "Already added this Rera No", // Adjust the error message as per requirement
        });
      }
    }
  };

  const handleFileField = (e) => {
    if (e.target.files) {
      const nextFormState = {
        ...form,
        [e.target.name]: e.target.files[0],
        [`${e.target.name}_name`]: e.target.files[0]?.name,
      };

   
        if (e.target.files.length) {
           
              const validFile = ValidateExtensionImge(e.target.files[0]);
              let preview = "";
              let image = "";
              if (validFile === true) {
                preview = URL.createObjectURL(e.target.files[0]);
                image = e.target.files[0];
                // setFormVaild({
                //   ...formVaild,
                //   images: null,
                //   validMedia: null,
                // });
              } else {
                preview = "";
                image = "";
                // setFormVaild({
                //   ...formVaild,
                //   images: null,
                //   validMedia: validFile,
                // });
              }
              const nextFormState = {
                preview: preview,
                raw: image,
              };
              if(e.target.name==="cancel_cheaque"){
              setCheaqueImage(nextFormState);
              }
              if(e.target.name==="propidership_declaration_letter"){
                setPropidershipImage(nextFormState);
                }
                if(e.target.name==="pancard"){
                  setPancardImage(nextFormState);
                  }
            }
      
      
      setForm(nextFormState);
    }
  };

  const handleRadio = (event) => {
    setCpType(Number(event.target.value));
  };

  const handleInputArea = (e) => {
    const nextFormState = {
      ...form,
      location: e,
      latitude: "",
      longitude: "",
    };
    setForm(nextFormState);
  };

  const onSelect = (latLng, location) => {
    const nextFormState = {
      ...form,
      location: location,
      latitude: latLng.lat,
      longitude: latLng.lng,
    };
    setForm(nextFormState);
  };

  const handleInputWorkingLocation = (e) => {
    console.log(e);
    const nextFormState = {
      ...form,
      workingLocation: e,
    };
    setForm(nextFormState);
  };

  const onSelectWorkingLocation = (latLng, location) => {
    let locArr =
      form.working_location === undefined ? [] : form.working_location;
    let locObj = {
      location: location,
      latitude: latLng.lat,
      longitude: latLng.lng,
    };
    if (locArr.length === 0) {
      locArr.push(locObj);
    } else {
      if (!locArr.some((i) => String(i.location) === String(location))) {
        locArr = [...locArr, locObj];
      }
    }
    const nextFormState = {
      ...form,
      workingLocation: "",
      working_location: locArr,
    };
    setForm(nextFormState);
  };

  const removeWorkLoc = (item) => {
    const nextFormState = {
      ...form,
      workingLocation: "",
      working_location: form.working_location.filter(
        (i) => String(i.location) !== String(item.location)
      ),
    };
    setForm(nextFormState);
  };

  const checkForDuplicateField = (fieldName, fieldValue) => {
    // Check if the value of the given field already exists in the employee list
    for (let i = 0; i < employee.length; i++) {
      if (employee[i][fieldName] === fieldValue) {
        return true;  // Return true if a duplicate is found
      }
    }
    return false;  // Return false if no duplicates
  };
  

  const addNewEmployee = () => {
    if (!handleEmployeeValid()) {
      setEmpFormVaild({
        employeeEmail: false,
        employeeMobile: false,
      });
      removeModalClass("exampleModal");
      employee.push(empform);
      setEmpform({
        employeeName: "",
        employeeMobile: "",
        employeeEmail: "",
        employeeGender: "",
        empolyeeReraNo:""
      });
    }
  };

  // const handleEmployeeValid = () => {
  //   let err = {};
  //   let formError = false;
  //   if (empform.employeeName === "") {
  //     formError = true;
  //     err["employeeName"] = strings.empNameErr;
  //   } else if (!nameValid(empform.employeeName)) {
  //     formError = true;
  //     err["employeeName"] = strings.nameValidErr;
  //   }
  //   if (empform.employeeMobile === "") {
  //     formError = true;
  //     err["employeeMobile"] = strings.empMobileErr;
  //   } else if (!mobileNumberValid(empform.employeeMobile)) {
  //     formError = true;
  //     err["employeeMobile"] = strings.mobileValidErr;
  //   } else if (empFormVaild?.employeeMobile) {
  //     formError = true;
  //     err["employeeMobile"] = empFormVaild?.employeeMobile;
  //   }
  //   if (empform.employeeEmail === "") {
  //     formError = true;
  //     err["employeeEmail"] = strings.empEmailErr;
  //   } else if (
  //     empform.employeeEmail &&
  //     !emailAddressValid(empform.employeeEmail)
  //   ) {
  //     formError = true;
  //     err["employeeEmail"] = strings.emailValidationErr;
  //   } else if (empFormVaild?.employeeEmail) {
  //     formError = true;
  //     err["employeeEmail"] = empFormVaild?.employeeEmail;
  //   }
  //   if (
  //     Number(empform.employeeGender) === 1 ||
  //     Number(empform.employeeGender) === 2
  //   ) {
  //   } else {
  //     formError = true;
  //     err["employeeGender"] = strings.genderErr;
  //   }
  //   if(empform.empolyeeReraNo!==""){
  //     if (!certificateNumber(empform.empolyeeReraNo)) {
  //       formError = true;
  //       err["empolyeeReraNo"] = strings.validCertificateNo;
  //     }
  //   }

    

  //   setEmpFormVaild(err);
  //   return formError;
  // };

  const handleEmployeeValid = () => {
    let err = {};
    let formError = false;
  
    // Check if employeeName is empty or invalid
    if (empform.employeeName === "") {
      formError = true;
      err["employeeName"] = strings.empNameErr;
    } else if (!nameValid(empform.employeeName)) {
      formError = true;
      err["employeeName"] = strings.nameValidErr;
    }
  
    // Check if employeeMobile is empty, invalid, or duplicate
    if (empform.employeeMobile === "") {
      formError = true;
      err["employeeMobile"] = strings.empMobileErr;
    } else if (!mobileNumberValid(empform.employeeMobile)) {
      formError = true;
      err["employeeMobile"] = strings.mobileValidErr;
    } else if (empFormVaild?.employeeMobile) {
      formError = true;
      err["employeeMobile"] = empFormVaild?.employeeMobile;
    } else {
      // Check for duplicate mobile number
      if (checkForDuplicateField("employeeMobile", empform.employeeMobile)) {
        formError = true;
        err["employeeMobile"] = "Already added this number";
      }
    }
  
    // Check if employeeEmail is empty, invalid, or duplicate
    if (empform.employeeEmail === "") {
      formError = true;
      err["employeeEmail"] = strings.empEmailErr;
    } else if (!emailAddressValid(empform.employeeEmail)) {
      formError = true;
      err["employeeEmail"] = strings.emailValidationErr;
    } else if (empFormVaild?.employeeEmail) {
      formError = true;
      err["employeeEmail"] = empFormVaild?.employeeEmail;
    } else {
      // Check for duplicate email
      if (checkForDuplicateField("employeeEmail", empform.employeeEmail)) {
        formError = true;
        err["employeeEmail"] = "Already added this Email";
      }
    }
  // 8794564565
    // Check if employeeGender is valid
    if (
      Number(empform.employeeGender) === 1 ||
      Number(empform.employeeGender) === 2
    ) {
    } else {
      formError = true;
      err["employeeGender"] = strings.genderErr;
    }
  
    // Check if RERA number is valid and not duplicate
    if (empform.empolyeeReraNo) {

      if (!certificateNumber(empform.empolyeeReraNo)) {
        formError = true;
        err["empolyeeReraNo"] = strings.validCertificateNo;
      } else if (checkForDuplicateField("empolyeeReraNo", empform.empolyeeReraNo)) {
        formError = true;
        err["empolyeeReraNo"] = "Already added this Rera No";
      }
    }
  
    setEmpFormVaild(err);
    return formError;
  };
  
  const handleDeleteEmployee = (index) => {
    const newArray = [...employee];
    newArray?.splice(index, 1);
    setEmployee(newArray);
  };

  const handleSubmit = () => {
    const isValid = handleValid();

    if (!handleValid()) {
      setFormVaild(null);

      const formData = new FormData();

      image.raw && formData.append("profile_picture", image.raw);
      cp_type && formData.append("cp_type", cp_type);
      form.owner_name && formData.append("owner_name", form.owner_name);
      form.owner_name && formData.append("agent_name", form.owner_name);
      form.primary_mobile &&
        formData.append("primary_mobile", form.primary_mobile);
      form.email && formData.append("email", form.email);
      form.rera_certificate_no &&
        formData.append("rera_certificate_no", form.rera_certificate_no);
      form.location && formData.append("location", form.location);
      form.latitude && formData.append("latitude", form.latitude);
      form.longitude && formData.append("longitude", form.longitude);
      form.gender && formData.append("gender", form.gender);
      form.date_of_birth &&
        formData.append("date_of_birth", form.date_of_birth);
      form.whatsapp_number &&
        formData.append("whatsapp_number", form.whatsapp_number);
      form.working_location &&
        formData.append(
          "working_location",
          JSON.stringify(form.working_location ? form.working_location : [])
        );
      form.rera_certificate &&
        formData.append("rera_certificate", form.rera_certificate);
        form.rera_start_date && formData.append("rera_start_date",form.rera_start_date)
        form.rera_end_date && formData.append("rera_end_date",form.rera_end_date)
      form.pancard && formData.append("pancard", form.pancard);
      form.gstApplicable &&
        formData.append("gstApplicable", form.gstApplicable);
      form.gst && formData.append("gst", form.gst);
      form.propidership_declaration_letter &&
        formData.append(
          "propidership_declaration_letter",
          form.propidership_declaration_letter
        );
      employee && formData.append("company_employee", JSON.stringify(employee));
      form.bank_name && formData.append("bank_name", form.bank_name);
      form.branch_name && formData.append("branch_name", form.branch_name);
      form.account_no && formData.append("account_no", form.account_no);
      form.ifsc_code && formData.append("ifsc_code", form.ifsc_code);
      form.cancel_cheaque &&
        formData.append("cancel_cheaque", form.cancel_cheaque);
      // cp_id: result?.cp_id
      form.pincode && formData.append("pincode", form.pincode);
      form.property_tag &&
        formData.append(
          "property_tag",
          form.property_tag?.length > 0 && !cpId
            ? JSON.stringify(form.property_tag)
            : []
        );
      if (cpId) {
        form.cp_id && formData.append("cp_id", form.cp_id);
        form.agency_id && formData.append("agency_id", form.agency_id);

        dispatch(updateChannelPartner(formData));
        navigatpage("/channelpartner");
      } else {
        dispatch(addChannelPartner(formData));
        navigatpage("/channelpartner");
      }
    }
  };

  useEffect(() => {
    dispatch(getReportPropertyList({ limit: 10, offset: 0 }));
  }, [dispatch]);

  const handleValid = () => {
    let err = {};
    let formError = false;
    if (cp_type === 1) {
      if (!form.owner_name) {
        formError = true;
        err["owner_name"] = strings.owner_Err;
      } else if (!nameValid(form.owner_name)) {
        formError = true;
        err["owner_name"] = strings.nameValidErr;
      }
      if (!form.primary_mobile) {
        formError = true;
        err["primary_mobile"] = strings.mobileErr;
      } else if (!mobileNumberValid(form.primary_mobile)) {
        formError = true;
        err["primary_mobile"] = strings.mobileValidErr;
      }
      if (form.whatsapp_number && !mobileNumberValid(form.whatsapp_number)) {
        formError = true;
        err["whatsapp_number"] = strings.mobileValidErr;
      }
      // Email made optional - commented out required validation
      // if (!form.email) {
      //   formError = true;
      //   err["email"] = strings.emailErr;
      // } else if (form.email && !emailAddressValid(form.email)) {
      if (form.email && !emailAddressValid(form.email)) {
        formError = true;
        err["email"] = strings.emailValidationErr;
      }
      if (Number(form.gender) === 1 || Number(form.gender) === 2) {
      } else {
        formError = true;
        err["gender"] = strings.genderErr;
      }
      if (form.date_of_birth && getAge(form.date_of_birth) < 18) {
        formError = true;
        err["date_of_birth"] = strings.dateofbirthErr2;
      }
      if (!form.location) {
        formError = true;
        err["location"] = strings.addressErr;
      }
      {
        /* 11-06-2024 */
      }
      // else if (!form.longitude) {
      //   formError = true;
      //   err["location"] = strings.validLctionErr;
      // } else if (form.longitude === "undefined") {
      //   formError = true;
      //   err["location"] = strings.validLctionErr;
      // }
      {
        /* 11-06-2024 */
      }

      if (!form.rera_certificate_no) {
        formError = true;
        err["rera_certificate_no"] = strings.rera_Number_Err;
      } else if (!certificateNumber(form.rera_certificate_no)) {
        formError = true;
        err["rera_certificate_no"] = strings.validCertificateNo;
      }
      if (form.account_no && !accountNumberValid(form.account_no)) {
        formError = true;
        err["account_no"] = strings.account_valid_Err;
      }
      if (form.ifsc_code && !ifscValid(form.ifsc_code)) {
        formError = true;
        err["ifsc_code"] = strings.ifsc_valid_Err;
      }
    } else if (cp_type === 2) {
      if (!form.owner_name) {
        formError = true;
        err["owner_name"] = strings.agency_Err;
      }
      if (!form.primary_mobile) {
        formError = true;
        err["primary_mobile"] = strings.mobileErr;
      } else if (!mobileNumberValid(form.primary_mobile)) {
        formError = true;
        err["primary_mobile"] = strings.mobileValidErr;
      }
      // Email made optional - commented out required validation
      // if (!form.email) {
      //   formError = true;
      //   err["email"] = strings.emailErr;
      // } else if (form.email && !emailAddressValid(form.email)) {
      if (form.email && !emailAddressValid(form.email)) {
        formError = true;
        err["email"] = strings.emailValidationErr;
      }
      if (form.gst && !gstNumberValid(form.gst)) {
        formError = true;
        err["gst"] = strings.gst_Valid_Err;
      }
      if (!form.rera_certificate_no) {
        formError = true;
        err["rera_certificate_no"] = strings.rera_register_Err;
      } else if (!certificateNumber(form.rera_certificate_no)) {
        formError = true;
        err["rera_certificate_no"] = strings.validReraRegister;
      }
      // if (!form.location) {
      //   formError = true;
      //   err["location"] = strings.addressErr;
      // } else if (!form.longitude) {
      //   formError = true;
      //   err["location"] = strings.validLctionErr;
      // } else if (form.longitude === "undefined") {
      //   formError = true;
      //   err["location"] = strings.validLctionErr;
      // }
      if (form.account_no && !accountNumberValid(form.account_no)) {
        formError = true;
        err["account_no"] = strings.account_valid_Err;
      }
      if (form.ifsc_code && !ifscValid(form.ifsc_code)) {
        formError = true;
        err["ifsc_code"] = strings.ifsc_valid_Err;
      }
      // if (employee?.length === 0) {
      //   formError = true;
      //   err["employee"] = strings.employee_Err;
      // }
      if (!form.pincode) {
        formError = true;
        err["pincode"] = strings.pincodeErr;
      }
      if (!form.rera_start_date) {
        formError = true;
        err["rera_start_date"] = strings.startDateErr;
      }
      if (!form.rera_end_date) {
        formError = true;
        err["rera_end_date"] = strings.endDateErr;
      }
      // Property allocation made optional - commented out required validation
      // if (form.property_tag.length === 0) {
      //   formError = true;
      //   err["allocateproperty"] = strings.allocatepropertytocp;
      // }
    }

    setFormVaild(err);
    return formError;
  };

  useEffect(() => {
    seo({
      title: "Add New CP",
      metaDescription: "Add new cp",
      canonicalLink: window.location.href,
    });
  }, []);

  const handleFile = (type) => {
    document.getElementById(type).click();
  };
  const formatDate = (date) => {
    const d = new Date(date);

    // Check if the date is valid before formatting
    if (isNaN(d.getTime())) {
      return ""; // Return empty string or a fallback date if the date is invalid
    }

    return d.toISOString().split("T")[0]; // Format to YYYY-MM-DD
  };

  // Ensure dates are formatted properly
  const formattedStartDate = formatDate(form?.rera_start_date);
  const formattedEndDate = formatDate(form?.rera_end_date);
  return (
    <div className="page-body">
      {/* Modal Start */}
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                {strings.addNewEmp}
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label htmlFor="exampleFormControlFirstName">
                      {strings.empName}
                      <span className="required-field"></span>
                    </label>
                    <input
                      className="form-control"
                      id="exampleFormControlFirstName"
                      type="text"
                      placeholder={strings.empName}
                      name="employeeName"
                      value={empform.employeeName}
                      onChange={handleEmployeeField}
                      autoComplete="off"
                    />
                    {empFormVaild?.employeeName && (
                      <span className style={{ color: "red" }}>
                        {empFormVaild?.employeeName}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.empMobile}
                      <span className="required-field"></span>
                    </label>
                    <input
                      className="form-control"
                      id="exampleInputMobileNo"
                      type="text"
                      maxLength={10}
                      name="employeeMobile"
                      value={empform.employeeMobile}
                      placeholder={strings.empMobile}
                      onChange={(e) => {
                        handleEmployeeField(e);
                        if (e.target.value.length >= 10) {
                          setEmpEmailMobile({
                            ...empEmailMobile,
                            employeeMobile: e.target.value,
                          });
                          dispatch(
                            checkEmailMobile({ mobile: e.target.value })
                          );
                        }
                      }}
                      autoComplete="off"
                      onKeyPress={(event) => {
                        if (/^[a-z]+$/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    {empFormVaild?.employeeMobile && (
                      <span className style={{ color: "red" }}>
                        {empFormVaild?.employeeMobile}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.empEmail}
                      <span className="required-field"></span>
                    </label>
                    <input
                      className="form-control"
                      id="exampleInputMobileNo"
                      autoComplete="off"
                      type="email"
                      name="employeeEmail"
                      value={empform.employeeEmail}
                      placeholder={strings.emailaddress}
                      onChange={(e) => {
                        handleEmployeeField(e);
                        if (emailAddressValid(e.target.value)) {
                          setEmpEmailMobile({
                            ...empEmailMobile,
                            employeeEmail: e.target.value,
                          });
                          dispatch(checkEmailMobile({ email: e.target.value }));
                        }
                        if (checkForDuplicateField("employeeEmail", e.target.value)) {
                          setEmpFormVaild({
                            ...formVaild,
                            employeeEmail:"Already added this Email", // Adjust the error message as per requirement
                          });
                        }
                      }}
                    />
                    {empFormVaild?.employeeEmail && (
                      <span className style={{ color: "red" }}>
                        {empFormVaild?.employeeEmail}
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                        <div className="mb-2">
                          <label htmlFor="exampleInputMobileNo">
                            {
                              strings.reraNo}
                          </label>
                          <input
                            className="form-control"
                            id="exampleInputMobileNo"
                            type="text"
                            maxLength={17}
                            name="empolyeeReraNo"
                            value={empform.empolyeeReraNo}
                            placeholder={
                              strings.reraNo
                            }
                            onChange={handleEmployeeField}
                            autoComplete="off"
                            onKeyPress={(event) => {
                              // Allow only numbers and alphabets (both uppercase and lowercase)
                              if (
                                !/[A-Za-z0-9]/.test(event.key) &&
                                !["Backspace", "Delete", "Tab"].includes(
                                  event.key
                                )
                              ) {
                                event.preventDefault(); // Prevent input of special characters
                              }
                            }}
                            readOnly={!!cpId} // If cpId exists, the input will be readonly
                            style={
                              cpId
                                ? {
                                    backgroundColor: "#f0f0f0",
                                    cursor: "not-allowed",
                                  }
                                : {}
                            } // Make it visually disabled
                          />
                          {empFormVaild?.empolyeeReraNo && (
                            <span style={{ color: "red" }}>
                              {empFormVaild?.empolyeeReraNo}
                            </span>
                          )}

                          {/* Show validation message when input is invalid */}
                  
                        </div>
                      </div>
                <div className="col-md-12">
                  <div className="mb-2">
                    <label htmlFor="exampleFormControlLastName">
                      {strings.gender}
                      <span className="required-field"></span>
                    </label>
                    <div className="col-md-12 form-group m-t-3 m-checkbox-inline mb-0 custom-radio-ml">
                      <div className="radio radio-primary col-md-4">
                        <input
                          id="radioLine11"
                          className="form-check-input"
                          type="radio"
                          name="employeeGender"
                          value={1}
                          checked={
                            Number(empform.employeeGender) === 1 ? true : false
                          }
                          onChange={handleEmployeeField}
                        />
                        <label className="mb-0" htmlFor="radioLine11">
                          {strings.male}
                        </label>
                      </div>
                      <div className="radio radio-primary col-md-4 mt-1">
                        <input
                          id="radioLine22"
                          className="form-check-input"
                          type="radio"
                          name="employeeGender"
                          value={2}
                          checked={
                            Number(empform.employeeGender) === 2 ? true : false
                          }
                          onChange={handleEmployeeField}
                        />

                        <label className="mb-0" htmlFor="radioLine22">
                          {strings.female}
                        </label>
                      </div>
                    </div>
                  </div>
                  {empFormVaild?.employeeGender && (
                    <span className style={{ color: "red" }}>
                      {empFormVaild?.employeeGender}
                    </span>
                  )}
                </div>
              
              </div>
            </div>
            <div class="modal-footer">
              <button
                className="btn btn-color"
                id="exampleModal"
                type="button"
                onClick={() => addNewEmployee()}
              >
                {strings.addNewEmp}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Modal End */}
      <Breadcrumb
        title={strings.addNewCP}
        url={"/channelpartner"}
        parentListing={strings.channelPartnerListing}
        titleactive={strings.addNewCP}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header row justify-content-sm-between pb-0">
                <h5>{strings.addNewCP}</h5>

                <div className="row pt-2 pb-2">
                  <div className="col-md-12">
                    <div>
                      <div className="col">
                        <div className="form-group m-t-8 m-checkbox-inline mb-0 custom-radio-ml">
                          {/* <div className="radio radio-primary mr-3">
                            <input
                              id="radioinline24"
                              type="radio"
                              name="cp_type"
                              value={1}
                              checked={Number(cp_type) === 1 ? true : false}
                              onChange={handleRadio}
                            />
                            <label className="mb-0" htmlFor="radioinline24">
                              {strings.individual}
                            </label>
                          </div> */}
                          <div className="radio radio-primary">
                            <input
                              id="radioinline25"
                              type="radio"
                              name="cp_type"
                              value={2}
                              checked={Number(cp_type) === 2 ? true : false}
                              onChange={handleRadio}
                            />
                            <label className="mb-0" htmlFor="radioinline25">
                              {strings.company}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <label htmlFor="upload-button">
                        <img
                          src={
                            image.preview
                              ? image.preview
                              : "/assets/images/user.png"
                          }
                          width="150"
                          height="150"
                          style={{ borderRadius: "50%" }}
                          color="red"
                          title={strings.selectImage}
                        />
                      </label>
                      <Input
                        type="file"
                        id="upload-button"
                        name="profile_picture"
                        style={{ display: "none" }}
                        onChange={handleChange}
                        accept="image/png, image/jpeg, image/jpg,image/JPG,image/PNG,image/JPEG"
                      />
                      <br />
                    </div>
                  </div>
                  {formVaild?.validMedia && (
                    <span style={{ color: "red" }}>{formVaild.validMedia}</span>
                  )}

                  <div className="row">
                    <>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlFirstName">
                            {cp_type === 1
                              ? strings.ownerName
                              : strings.realStateCompany}
                            <span className="required-field"></span>
                          </label>
                          <input
                            className="form-control"
                            id="exampleFormControlFirstName"
                            type="text"
                            placeholder={
                              cp_type === 1
                                ? strings.ownerName
                                : strings.realStateCompany
                            }
                            name="owner_name"
                            value={form.owner_name}
                            onChange={handleInputField}
                            autoComplete="off"
                          />
                          {formVaild?.owner_name && (
                            <span style={{ color: "red" }}>
                              {formVaild?.owner_name}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="exampleInputMobileNo">
                            {cp_type === 1
                              ? strings.mobileNo
                              : strings.companyMobile}
                            <span className="required-field"></span>
                          </label>
                          <input
                            className="form-control"
                            id="exampleInputMobileNo"
                            type="text"
                            maxLength={10}
                            name="primary_mobile"
                            value={form.primary_mobile}
                            placeholder={
                              cp_type === 1
                                ? strings.mobileNo
                                : strings.companyMobile
                            }
                            onChange={handleInputField}
                            autoComplete="off"
                            onKeyPress={(event) => {
                              if (/^[a-z]+$/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            readOnly={!!cpId} // If cpId exists, the input will be readonly
                            style={
                              cpId
                                ? {
                                    backgroundColor: "#f0f0f0",
                                    cursor: "not-allowed",
                                  }
                                : {}
                            } // Make it visually disabled
                          />
                          {formVaild?.primary_mobile && (
                            <span style={{ color: "red" }}>
                              {formVaild?.primary_mobile}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="exampleInputMobileNo">
                            {cp_type === 1
                              ? strings.emailAddress
                              : strings.companyMailID}
                          </label>
                          <input
                            className="form-control"
                            id="exampleInputMobileNo"
                            autoComplete="off"
                            type="email"
                            name="email"
                            value={form.email}
                            placeholder={strings.emailaddress}
                            onChange={handleInputField}
                            readOnly={!!cpId} // If cpId exists, the input will be readonly
                            style={
                              cpId
                                ? {
                                    backgroundColor: "#f0f0f0",
                                    cursor: "not-allowed",
                                  }
                                : {}
                            } // Make it visually disabled
                          />
                          {formVaild?.email && (
                            <span style={{ color: "red" }}>
                              {formVaild?.email}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="exampleInputMobileNo">
                            {cp_type === 1
                              ? strings.reraCertiNumber
                              : strings.reraRegistration}
                            <span className="required-field"></span>
                          </label>
                          <input
                            className="form-control"
                            id="exampleInputMobileNo"
                            type="text"
                            maxLength={17}
                            name="rera_certificate_no"
                            value={form.rera_certificate_no}
                            placeholder={
                              cp_type === 1
                                ? strings.reraCertiNumber
                                : strings.reraRegistration
                            }
                            onChange={handleInputField}
                            autoComplete="off"
                            onKeyPress={(event) => {
                              // Allow only numbers and alphabets (both uppercase and lowercase)
                              if (
                                !/[A-Za-z0-9]/.test(event.key) &&
                                !["Backspace", "Delete", "Tab"].includes(
                                  event.key
                                )
                              ) {
                                event.preventDefault(); // Prevent input of special characters
                              }
                            }}
                            readOnly={!!cpId} // If cpId exists, the input will be readonly
                            style={
                              cpId
                                ? {
                                    backgroundColor: "#f0f0f0",
                                    cursor: "not-allowed",
                                  }
                                : {}
                            } // Make it visually disabled
                          />
                          {formVaild?.rera_certificate_no && (
                            <span style={{ color: "red" }}>
                              {formVaild?.rera_certificate_no}
                            </span>
                          )}

                          {/* Show validation message when input is invalid */}
                          {form.rera_certificate_no &&
                            !reraRegex.test(form.rera_certificate_no) && (
                              <div
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginTop: "5px",
                                }}
                              >
                                {strings.reraValidationMsg}
                              </div>
                            )}
                        </div>
                      </div>

                      {showModal && (
                        <div
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark background with transparency
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            animation: "fadeInBackground 0.3s ease-in-out",
                            backdropFilter: "blur(10px)", // Apply blur effect on the background
                            zIndex: 10, // Ensure it stays on top
                          }}
                          role="dialog"
                          aria-labelledby="modal-title"
                          aria-hidden="true"
                        >
                          <div
                            style={{
                              backgroundColor: "#fff",
                              borderRadius: "8px",
                              width: "80%",
                              maxWidth: "500px",
                              padding: "20px",
                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                              animation: "fadeInModal 0.3s ease-in-out", // Modal fade-in animation
                              zIndex: 20, // Ensure modal stays in the front
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                borderBottom: "1px solid #ddd",
                                paddingBottom: "10px",
                              }}
                            >
                              <h2
                                id="modal-title"
                                style={{
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                  margin: 0,
                                }}
                              >
                                CP is Already Registered
                              </h2>
                              <button
                                onClick={handleCloseModal}
                                style={{
                                  background: "none",
                                  border: "none",
                                  fontSize: "24px",
                                  cursor: "pointer",
                                  color: "#333",
                                }}
                                aria-label="Close"
                              >
                                &times;
                              </button>
                            </div>
                            <div
                              style={{
                                margin: "20px 0",
                                fontSize: "16px",
                                textAlign: "center",
                              }}
                            >
                              <p>Do you want to allocate your property?</p>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                gap: "10px",
                              }}
                            >
                              <button
                                onClick={handleCloseModal}
                                style={{
                                  backgroundColor: "#f0f0f0",
                                  border: "none",
                                  padding: "10px 20px",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                  color: "#333",
                                }}
                              >
                                No
                              </button>
                              <button
                                onClick={handleConfirm}
                                style={{
                                  backgroundColor: "#007bff",
                                  border: "none",
                                  padding: "10px 20px",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  fontSize: "16px",
                                  color: "#fff",
                                }}
                              >
                                Yes
                              </button>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="formControlReraStartDate">
                            {strings.reraStartDate}
                            <span className="required-field"></span>
                          </label>
                          <input
                            className="form-control"
                            id="formControlReraStartDate"
                            type="date"
                            name="rera_start_date"
                            value={formattedStartDate}
                            onChange={handleInputField}
                            autoComplete="off"
                            readOnly={!!cpId}
                            max={new Date().toISOString().split("T")[0]}
                          />
                          {formVaild?.rera_start_date && (
                            <span style={{ color: "red" }}>
                              {formVaild?.rera_start_date}
                            </span>
                          )}
                        </div>
                      </div>


                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="formControlReraEndDate">
                            {strings.reraEndDate}
                            <span className="required-field"></span>
                          </label>
                          <input
                            className="form-control"
                            id="formControlReraEndDate"
                            type="date"
                            name="rera_end_date"
                            value={formattedEndDate}
                            onChange={handleInputField}
                            autoComplete="off"
                            readOnly={!!cpId}
                          />
                          {formVaild?.rera_end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild?.rera_end_date}
                            </span>
                          )}
                        </div>
                      </div>
                      {/* 11-06-2024 */}
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="formControlAddress">
                            {cp_type === 1
                              ? strings.address
                              : strings.companyAddress}
                            <span></span>
                          </label>
                          <input
                            className="form-control"
                            id="formControlAddress"
                            type="text"
                            placeholder={
                              cp_type === 1
                                ? strings.address
                                : strings.companyAddress
                            }
                            name="location"
                            value={form.location}
                            onChange={handleInputField}
                            autoComplete="off"
                          />
                          {formVaild?.location && (
                            <span style={{ color: "red" }}>
                              {formVaild?.location}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="formControlPincode">
                            {strings.pincode}
                            <span className="required-field"></span>
                          </label>
                          <input
                            className="form-control"
                            id="formControlPincode"
                            disableSpecialCharacters={true}
                            require={true}
                            type="text"
                            placeholder={strings.pincode}
                            name="pincode"
                            value={form.pincode}
                            onChange={handleInputField}
                            maxLength={6}
                            autoComplete="off"
                          />
                          {formVaild?.pincode && (
                            <span style={{ color: "red" }}>
                              {formVaild?.pincode}
                            </span>
                          )}
                        </div>
                      </div>
                      {/* 11-06-2024 */}
                      {/* 11-06-2024 */}
                      {/* <div className="col-md-6">
                        <div className="mb-3">
                          <AutocompletePlace
                            placeholder={
                              cp_type === 1
                                ? strings.address
                                : strings.companyAddress
                            }
                            value={form.location}
                            onChange={handleInputArea}
                            onSelect={onSelect}
                            error={formVaild?.location}
                            label={
                              cp_type === 1
                                ? strings.address
                                : strings.companyAddress
                            }
                            requiredLabel={true}
                          />
                        </div>
                      </div> */}
                      {/* 11-06-2024 */}
                      {cp_type === 1 ? (
                        <>
                          <div className="col-md-6">
                            <div className="mb-2">
                              <label
                                htmlFor="exampleFormControl"
                                className="pr-4"
                              >
                                {strings.gender}
                                <span className="required-field"></span>
                              </label>
                              <div className="col pt-2">
                                <div className="form-group m-t-8 m-checkbox-inline mb-0 custom-radio-ml">
                                  <div className="radio radio-primary mr-3">
                                    <input
                                      id="gender1"
                                      type="radio"
                                      name="gender"
                                      value={1}
                                      onChange={handleInputField}
                                    />
                                    <label className="mb-0" htmlFor="gender1">
                                      {strings.male}
                                    </label>
                                  </div>
                                  <div className="radio radio-primary">
                                    <input
                                      id="gender2"
                                      type="radio"
                                      name="gender"
                                      value={2}
                                      onChange={handleInputField}
                                    />
                                    <label className="mb-0" htmlFor="gender2">
                                      {strings.female}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              {formVaild?.gender && (
                                <span style={{ color: "red" }}>
                                  {formVaild?.gender}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label htmlFor="exampleInputMobileNo">
                                {strings.dateofBirth}
                              </label>
                              <input
                                className="form-control"
                                id="exampleInputMobileNo"
                                type="Date"
                                name="date_of_birth"
                                value={form.date_of_birth}
                                onChange={handleInputField}
                                min="1920-01-01"
                                max={moment()
                                  .subtract(18, "years")
                                  .format("yyyy-MM-DD")}
                              />
                              {formVaild?.date_of_birth && (
                                <span style={{ color: "red" }}>
                                  {formVaild?.date_of_birth}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label htmlFor="exampleInputMobileNo">
                                {strings.whatsappNo}
                              </label>
                              <input
                                className="form-control"
                                id="exampleInputMobileNo"
                                type="text"
                                maxLength={10}
                                name="whatsapp_number"
                                value={form.whatsapp_number}
                                placeholder={strings.whatsappNo}
                                onChange={handleInputField}
                                autoComplete="off"
                                onKeyPress={(event) => {
                                  if (/^[a-z]+$/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                              {formVaild?.whatsapp_number && (
                                <span style={{ color: "red" }}>
                                  {formVaild?.whatsapp_number}
                                </span>
                              )}
                            </div>
                          </div>
                          {/* 11-06-2024 */}
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label htmlFor="formControlLocationArea">
                                {strings.workingLocation}
                              </label>
                              <input
                                className="form-control"
                                id="formControlLocationArea"
                                type="text"
                                placeholder={strings.workingLocation}
                                name="workingLocation"
                                value={form.workingLocation}
                                onChange={handleInputField}
                                autoComplete="off"
                              />
                              {formVaild?.area && (
                                <span style={{ color: "red" }}>
                                  {formVaild?.area}
                                </span>
                              )}
                            </div>
                          </div>
                          {/* 11-06-2024 */}
                          {/* 11-06-2024 */}
                          {/* <div className="col-md-6">
                            <div className="mb-3">
                              <label htmlFor="exampleFormControlSelect9">
                                {strings.workingLocation}
                              </label>
                              <AutocompletePlace
                                placeholder={strings.workingLocation}
                                value={form.workingLocation}
                                onChange={handleInputWorkingLocation}
                                onSelect={onSelectWorkingLocation}
                                error={formVaild?.area}
                              />
                              <div className="row mt-1 ml-2">
                                {form?.working_location &&
                                  form?.working_location.map((item, i) => (
                                    <div className="mt-1" key={i}>
                                      <small
                                        className="btn-color"
                                        style={{
                                          borderRadius: 20,
                                          padding: "5px",
                                          margin: 2,
                                        }}
                                      >
                                        {item.location}{" "}
                                        <i
                                          onClick={() => removeWorkLoc(item)}
                                          className="fa fa-times ml-3"
                                          style={{ cursor: "pointer" }}
                                        ></i>
                                      </small>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div> */}
                          {/* 11-06-2024 */}
                        </>
                      ) : null}
                      <div className="col-md-6">
                        <div className="mb-1">
                          <label htmlFor="exampleInputMobileNo">
                            {cp_type === 1
                              ? strings.reraCertificate
                              : strings.companyReraCertificate}
                          </label>
                          <div
                            className="d-flex border_one"
                            onClick={() => handleFile("file444")}
                          >
                            <div className="border">{strings.chooseFile}</div>
                            <div
                              style={{
                                paddingLeft: "10px",
                                fontSize: "16px",
                              }}
                            >
                              {form?.rera_certificate_name
                                ? form?.rera_certificate_name
                                : "No file chosen"}
                            </div>
                          </div>
                          <input
                            className="form-control"
                            id="file444"
                            type="file"
                            name="rera_certificate"
                            accept="image/*,application/pdf"
                            onChange={handleFileField}
                            style={{ display: "none" }}
                          />
                        </div>
                        {cpId && (
  <div>
    {cpdata?.rera_certificate ? (
      // Check if the file extension is PDF
      getFileExtension(form.rera_certificate) === "pdf" ? (
        <a
          onClick={() => {
            setPdfUrl(form.rera_certificate);
            setIsPdfView(true);
          }}
        >
          <img
            src="/assets/images/documentIcon.png"
            className="img-fluid view_pro"
            alt={form.rera_certificate}
          />
        </a>
      ) : (
        // Fallback: Render ImageRender component if not PDF

        <ImageRender
          imageUrl={cpdata?.rera_certificate}
          thumbnailUrl={cpdata?.rera_certificate}
        />
      )
    ) : (
      strings.notavailable
    )}
  </div>
)}

                      </div>
                      {cp_type === 1 ? null : (
                        <div className="col-md-6">
                          <div>
                            <label htmlFor="exampleInputMobileNo">
                              {strings.pancard}
                            </label>
                            <div
                              className="d-flex border_one"
                              onClick={() => handleFile("file333")}
                            >
                              <div className="border">{strings.chooseFile}</div>
                              <div
                                style={{
                                  paddingLeft: "10px",
                                  fontSize: "16px",
                                }}
                              >
                                {form?.pancard_name
                                  ? form?.pancard_name
                                  : "No file chosen"}
                              </div>
                            </div>
                            <input
                              className="form-control"
                              id="file333"
                              type="file"
                              name="pancard"
                              accept="image/*"
                              onChange={handleFileField}
                              style={{ display: "none" }}
                            />
                          </div>
                          {cpId && (
    <div>
      {cpdata?.pancard ? (
        getFileExtension(form.pancard) === "pdf" ? (
          <a
            onClick={() => {
              setPdfUrl(form.pancard);
              setIsPdfView(true);
            }}
          >
            <img
              src="/assets/images/documentIcon.png"
              className="img-fluid view_pro"
              alt={form.pancard}
            />
          </a>
        ): form?.pancard && form.pancard !== cpdata?.pancard ? (
          // Render the image preview if form.cancel_cheaque is different from cpdata
          <img
            src={pancardImage.preview} // Assuming cheaqueImage.preview holds the preview URL
            width="150"
            height="150"
            alt="Preview"
          />
        ) : (
          // Fallback: Render ImageRender component if no preview
          <ImageRender
          imageUrl={cpdata?.pancard}
          thumbnailUrl={
            cpdata?.pancard
          }
          />
        )
      ) : (
        strings.notavailable
      )}
    </div>
  )}
                        </div>
                      )}

                      {cp_type === 1 || cpId != null ? null : (
                        <div className="col-md-6">
                          <div className="form-group mb-0">
                            <label htmlFor="exampleFormControlFirstName">
                              {strings.employee}
                            </label>
                          </div>
                          <div className="form-group">
                            <button
                              className="btn btn-color"
                              type="button"
                              data-toggle="modal"
                              data-target="#exampleModal"
                            >
                              {strings.addNewEmp}
                            </button>
                          </div>
                          {formVaild?.employee && (
                            <span style={{ color: "red" }}>
                              {formVaild?.employee}
                            </span>
                          )}
                        </div>
                      )}
                      <div className="col-md-12">
                        <div>
                          <label htmlFor="exampleFormControl">
                            {strings.applicableforGST}
                          </label>
                          <div className="col">
                            <div className="form-group m-t-8 m-checkbox-inline mb-0 custom-radio-ml">
                              <div className="radio radio-primary mr-3">
                                <input
                                  id="radioinline26"
                                  type="radio"
                                  name="gstApplicable"
                                  value={1}
                                  checked={
                                    Number(form.gstApplicable) === 1
                                      ? true
                                      : false
                                  }
                                  onChange={handleInputField}
                                />
                                <label className="mb-0" htmlFor="radioinline26">
                                  {strings.yes}
                                </label>
                              </div>
                              <div className="radio radio-primary">
                                <input
                                  id="radioinline27"
                                  type="radio"
                                  name="gstApplicable"
                                  value={0}
                                  checked={
                                    Number(form.gstApplicable) === 0
                                      ? true
                                      : false
                                  }
                                  onChange={handleInputField}
                                />
                                <label className="mb-0" htmlFor="radioinline27">
                                  {strings.no}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {Number(form.gstApplicable) === 1 ? (
                        <div className="col-md-6 pt-2">
                          <div className="mb-3">
                            <label htmlFor="exampleInputMobileNo">
                              {cp_type === 1 ? strings.gst : strings.companyGST}
                            </label>
                            <input
                              className="form-control"
                              id="exampleInputMobileNo"
                              type="text"
                              name="gst"
                              maxLength={15}
                              value={form.gst}
                              placeholder={
                                cp_type === 1 ? strings.gst : strings.companyGST
                              }
                              onChange={handleInputField}
                              autoComplete="off"
                              style={{ textTransform: "uppercase" }}
                            />
                            {formVaild?.gst && (
                              <span style={{ color: "red" }}>
                                {formVaild?.gst}
                              </span>
                            )}
                          </div>
                        </div>
                      ) : null}
                      {Number(form.gstApplicable) === 0 ? (
                        <div className="col-md-6 pt-2">
                          <div className="mb-3">
                            <label htmlFor="exampleInputMobileNo">
                              {cp_type === 1
                                ? strings.propDeclarLetter
                                : strings.companyDeclarLetter}
                            </label>
                            <div
                              className="d-flex border_one"
                              onClick={() => handleFile("file222")}
                            >
                              <div className="border">{strings.chooseFile}</div>
                              <div
                                style={{
                                  paddingLeft: "10px",
                                  fontSize: "16px",
                                }}
                              >
                                {form?.propidership_declaration_letter_name
                                  ? form?.propidership_declaration_letter_name
                                  : "No file chosen"}
                              </div>
                            </div>
                            <input
                              className="form-control"
                              id="file222"
                              type="file"
                              name="propidership_declaration_letter"
                              accept="image/*,application/pdf"
                              onChange={handleFileField}
                              style={{ display: "none" }}
                            />
                          </div>
                          {cpId && (
    <div>
      {cpdata?.propidership_declaration_letter ? (
        getFileExtension(form.propidership_declaration_letter) === "pdf" ? (
          <a
            onClick={() => {
              setPdfUrl(form.propidership_declaration_letter);
              setIsPdfView(true);
            }}
          >
            <img
              src="/assets/images/documentIcon.png"
              className="img-fluid view_pro"
              alt={form.propidership_declaration_letter}
            />
          </a>
        ): form?.propidership_declaration_letter && form.propidership_declaration_letter !== cpdata?.propidership_declaration_letter ? (
          // Render the image preview if form.cancel_cheaque is different from cpdata
          <img
            src={propidershipImage.preview} // Assuming cheaqueImage.preview holds the preview URL
            width="150"
            height="150"
            alt="Preview"
          />
        ) : (
          // Fallback: Render ImageRender component if no preview
          <ImageRender
          imageUrl={cpdata?.propidership_declaration_letter}
          thumbnailUrl={
            cpdata?.propidership_declaration_letter
          }
          />
        )
      ) : (
        strings.notavailable
      )}
    </div>
  )}
                        </div>
                        
                      ) : null}

                      {cp_type === 1 ? null : employee?.length > 0 ? (
                        <div className="col-md-12">
                          <div className="card">
                            <div className="card-header"></div>
                            <div className="table-responsive">
                              <table class="table">
                                <thead className="text-center">
                                  <tr>
                                    <th scope="col">{strings.empName}</th>
                                    <th scope="col">{strings.empMobile}</th>
                                    <th scope="col">{strings.empEmail}</th>
                                    <th scope="col">{strings.gender}</th>
                                    <th scope="col">{strings.action}</th>
                                  </tr>
                                </thead>
                                <tbody className="text-center">
                                  {employee?.length > 0 ? (
                                    employee.map((item, index) => {
                                      return (
                                        <tr key={index}>
                                          <td>{item.employeeName}</td>
                                          <td>{item.employeeMobile}</td>
                                          <td>{item.employeeEmail}</td>
                                          <td>
                                            {item.employeeGender === "1"
                                              ? "Male"
                                              : item.employeeGender === "2"
                                              ? "Female"
                                              : null}
                                          </td>
                                          <td>
                                            <i
                                              className="fa fa-trash theme-fa-icon p-2 mr-1"
                                              aria-hidden="true"
                                              title={strings.removeEmp}
                                              onClick={() => {
                                                handleDeleteEmployee(index);
                                              }}
                                            ></i>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr />
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className="row mt-4">
                        {/* Left side: Allocate Property */}
                        {!cpId && (
                          <>
                            <div className="col-md-8 d-flex align-items-center justify-content-center">
                              <label
                                name="allocateproperty"
                                htmlFor="allocateProperty"
                                className="form-label"
                              >
                                Allocate Property
                              </label>
                            </div>

                            <div className="col-md-4 d-flex align-items-center justify-content-end">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleAllocateClick}
                              >
                                Allocate
                              </button>
                            </div>

                            <AllocatePropertyModal
                              show={modalShow}
                              cp_id={form.cp_lg_id}
                              handleClose={handleCloseModal}
                              onPropertiesSelected={handlePropertiesSelected}
                            />
                          </>
                        )}

                        {/* Selected Properties Section */}
                        <div className="col-md-12 mt-4 justify-content-center">
                          <h6 className="">
                            {cpId
                              ? "Allocated Properties"
                              : "Selected Properties"}
                          </h6>{" "}
                          {/* Center the title */}
                          <div className="row justify-content-center">
                            {" "}
                            {/* Center the properties */}
                            {selectedProperties.length > 0 ? (
                              selectedProperties.map((property) => (
                                <div className="col-2 mb-4" key={property._id}>
                                  <div
                                    className="card shadow-sm d-flex flex-column align-items-center justify-content-center"
                                    style={{
                                      maxHeight: "70px",
                                      width: "100%",
                                      padding: "5px",
                                    }}
                                  >
                                    <div className="card-body d-flex align-items-center justify-content-center">
                                      <h5
                                        className="card-title text-center"
                                        style={{
                                          overflow: "hidden",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {property.property_title}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="col-12 text-center">
                                <p>No properties selected.</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 mb-3 pt-3">
                        <h3>
                          {cp_type === 1
                            ? strings.bankDetailUser
                            : strings.bankDetailCompany}
                        </h3>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.bankName}
                          </label>
                          <input
                            className="form-control"
                            id="exampleInputMobileNo"
                            type="text"
                            name="bank_name"
                            value={form.bank_name}
                            placeholder={strings.bankName}
                            onChange={handleInputField}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.branchName}
                          </label>
                          <input
                            className="form-control"
                            id="exampleInputMobileNo"
                            type="text"
                            value={form.branch_name}
                            name="branch_name"
                            placeholder={strings.branchName}
                            onChange={handleInputField}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.accountNo}
                          </label>
                          <input
                            className="form-control"
                            id="exampleInputMobileNo"
                            type="text"
                            name="account_no"
                            maxLength={18}
                            value={form.account_no}
                            placeholder={strings.accountNo}
                            onChange={handleInputField}
                            autoComplete="off"
                            onKeyPress={(event) => {
                              if (/^[A-Za-z]+$/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                          {formVaild?.account_no && (
                            <span style={{ color: "red" }}>
                              {formVaild?.account_no}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.ifscCode}
                          </label>
                          <input
                            className="form-control"
                            id="exampleInputMobileNo"
                            type="text"
                            name="ifsc_code"
                            maxLength={15}
                            value={form.ifsc_code}
                            placeholder={strings.ifscCode}
                            onChange={handleInputField}
                            autoComplete="off"
                            style={{ textTransform: "uppercase" }}
                          />
                          {formVaild?.ifsc_code && (
                            <span style={{ color: "red" }}>
                              {formVaild?.ifsc_code}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.cancelCheaque}
                          </label>
                          <div
                            className="d-flex border_one"
                            onClick={() => handleFile("file111")}
                          >
                            <div className="border">{strings.chooseFile}</div>
                            <div
                              style={{ paddingLeft: "10px", fontSize: "16px" }}
                            >
                              {form?.cancel_cheaque_name
                                ? form?.cancel_cheaque_name
                                : "No file chosen"}
                            </div>
                          </div>
                          <input
                            className="form-control"
                            id="file111"
                            type="file"
                            name="cancel_cheaque"
                            accept="image/*,application/pdf"
                            onChange={handleFileField}
                            style={{ display: "none" }}
                          />
                        </div>
                        {cpId && (
    <div>
      {cpdata?.cp_bank_detail?.cancel_cheaque ? (
        getFileExtension(form.cancel_cheaque) === "pdf" ? (
          <a
            onClick={() => {
              setPdfUrl(cpdata?.base_url + form.cancel_cheaque);
              setIsPdfView(true);
            }}
          >
            <img
              src="/assets/images/documentIcon.png"
              className="img-fluid view_pro"
              alt={form.cancel_cheaque}
            />
          </a>
        ): form?.cancel_cheaque && form.cancel_cheaque !== cpdata?.cp_bank_detail?.cancel_cheaque ? (
          // Render the image preview if form.cancel_cheaque is different from cpdata
          <img
            src={cheaqueImage.preview} // Assuming cheaqueImage.preview holds the preview URL
            width="150"
            height="150"
            alt="Preview"
          />
        ) : (
          // Fallback: Render ImageRender component if no preview
          <ImageRender
            baseUrl={cpdata?.base_url}
            imageUrl={cpdata?.cp_bank_detail?.cancel_cheaque}
            thumbnailUrl={cpdata?.cp_bank_detail?.cancel_cheaque}
          />
        )
      ) : (
        strings.notavailable
      )}
    </div>
  )}
                      </div>
                    </>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleSubmit()}
                      >
                        {strings.submit}
                      </button>
                    </div>
                  </div>
                  {formVaild !== null && (
                    <div className="col-md-12 float-right">
                      <span
                        style={{
                          color: "red",
                          float: "right",
                        }}
                      >
                        {strings.allFieldRequired}
                      </span>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddNewCP;
